import Loader from 'react-loader-spinner';
import { DashCircle, Search } from "react-bootstrap-icons";
import { Button, Modal, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { setCustomerPopup } from '../store/api/Modals';
import React, { useEffect, useState, useRef } from 'react';
import { CheckSquare, Eye, EyeSlash, X } from 'react-bootstrap-icons';
import { getAllProvinces, getCityList } from '../store/api/LocationAPI';
import { getCustomerBaseInfoes, searchCustomer, searchPreCustomer } from "../store/api/CustomerApi";


const ModalSelectCustomer = () => {
    const searchData = useRef({});
    const dispatch = useDispatch();
    const [showFilters, setShowFilters] = useState(true);
    let [selectedItems, selectItems] = useState([]);
    const popup = useSelector(state => state.popup.selectCustomerPop);
    const { show, onSelect, onSelectOne, onSelectWithNames } = popup;
    const { provinceList, cityList } = useSelector(state => {
        return {
            provinceList: state.locationDataReducer.provinceList,
            cityList: state.locationDataReducer.cityList
        }
    });
    const { customerList, baseInfoes } = useSelector(state => {
        return {
            customerList: searchData.current.Type === "preCustomer" ?
                state.customerDataReducer.preCustomerList4Select : state.customerDataReducer.customerList4Select,
            baseInfoes: state.customerDataReducer.customerBaseInfoes
        }
    });

    useEffect(() => {
        dispatch(getCustomerBaseInfoes());
        if (!provinceList || provinceList === "" || provinceList.length === 0)
            dispatch(getAllProvinces());

    }, []);
    const close = () => {
        searchData.current = {};
        searchData.current.Type = "customer";
        selectItems([]);
        if (onSelect) {
            onSelect(searchData.current.Type, []);
        }
        else if (onSelectOne) {
            onSelectOne(searchData.current.Type, null);
        }
        else if (onSelectWithNames) {
            onSelectWithNames(searchData.current.Type, null);
        }
        dispatch(setCustomerPopup({ show: false }));
    }

    const loadCityList = (provinceID) => {
        searchData.current.ProvinceID = provinceID;
        dispatch(getCityList(provinceID));
    }
    const search = (e) => {
        if(e.key && e.key !=="Enter")
        {
            return;
        }
        selectedItems = [];
        searchData.current.Take = 0;
        searchData.current.RelatedCustomerID = -1;
        if (searchData.current.CampaignID === undefined) {
            searchData.current.CampaignID = -1;
        }
        if (!searchData.current.Type || searchData.current.Type === "customer") {
            dispatch(searchCustomer(searchData.current, true));
        }
        else {
            dispatch(searchPreCustomer(searchData.current, true));
        }
    }
    const setSelectedItems = (add, item) => {
        if (item) {
            if (add) {
                selectItems([...selectedItems, item.ID]);
            }
            else {
                selectItems(selectedItems.filter(i => item.ID !== i));
            }
        }
    }
    const selectAll = (value) => {
        if (!value) {
            selectItems([]);
        }
        else if (customerList.Data) {
            selectItems(customerList.Data.map(c => c.ID));
        }
    }
    const find = () => {
        if (document.getElementById("inputSearch")) {
            let str = document.getElementById("inputSearch").value;
            if (str === "") {
                return;
            }
            var elList = document.getElementById("custList").querySelectorAll(".resultTableRow");
            for (let i = 0; i < elList.length; i++) {
                if (elList[i].textContent.search(str) > -1) {
                    elList[i].scrollIntoView();
                    elList[i].color = "red";
                }
            }
        }
    }
    const select = () => {
        if (onSelect) {
            onSelect(searchData.current.Type ?? "customer", [...selectedItems]);
        }
        else if (onSelectOne) {
            const custID = selectedItems.pop();
            const customer = customerList.Data.find(c => c.ID === custID);
            onSelectOne(searchData.current.Type ?? "customer", customer);
        }
        else if (onSelectWithNames) {
            const selectedCustomers = customerList.Data.filter(ul => selectedItems.find(i => i === ul.ID));
            onSelectWithNames(searchData.current.Type ?? "customer", selectedCustomers);
        }
        // if (popup.setCustomerLocation) {
        //     popup.setCustomerLocation(item.ProvinceID, item.CityID);
        // }
        searchData.current = {};
        searchData.current.Type = "customer";
        selectItems([]);
        dispatch(setCustomerPopup({ show: false }));
    }
    return (
        <Modal show={show} style={{ direction: "rtl" }} size="lg" onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#e40375' }}>انتخاب مشتری از لیست<span style={{ cursor: "pointer" }}><X size={20} onClick={close} /></span></Modal.Header>
            <Modal.Body>
                <Button style={{ position: "absolute", top: "5px", left: "10px", padding: "0 2px 0 2px", boxShadow: "1px 2px 3px black" }} onClick={() => setShowFilters(!showFilters)}>{!showFilters && <Eye />}{showFilters && <EyeSlash />}</Button>
                {showFilters &&
                    <div className="row mt-2" style={{ marginBottom: "5px" }}>
                        <div className="form-group col-md-3  mt-0">
                            <select className='form-control' placeholder='نوع'
                                onChange={(e) => { searchData.current.Type = e.target.value; selectItems([]); }}>
                                <option value="customer">مشتری</option>
                                <option value="preCustomer">مشتری بالقوه</option>
                            </select>
                        </div>
                        <div className="form-group col-md-3  mt-0">
                            <input type="text" placeholder="نام" className="form-control" onChange={(e) => searchData.current.Name = e.target.value} onKeyDown={search}/>
                        </div>
                        <div className="form-group col-md-3 mt-0">
                            <input type="number" placeholder="شماره تلفن/همراه" className="form-control" onChange={(e) => searchData.current.Mobile = e.target.value} onKeyDown={search} />
                        </div>
                        <div className="form-group col-md-3  mt-0">
                            <select className='form-control' placeholder='گروه مشتری'
                                onChange={(e) => searchData.current.GroupID = e.target.value}>
                                <option>گروه را انتخاب کنید</option>
                                {baseInfoes?.GroupList && Array.isArray(baseInfoes.GroupList) &&
                                    baseInfoes.GroupList.map((item, i) =>
                                        <option key={i} value={item.ID}>{item.Group}</option>
                                    )
                                }
                            </select>
                        </div>
                        <div className="form-group col-md-3 mt-0">
                            <select className='form-control' placeholder='رسته شغلی'
                                onChange={e => {
                                    searchData.current.Job = baseInfoes.JobList.find(j => j.JobId === Number(e.target.value))?.Job;
                                    searchData.current.JobId = e.target.value
                                }}>
                                <option value="">رسته شغلی را انتخاب کنید</option>
                                { baseInfoes?.JobList && Array.isArray(baseInfoes.JobList) &&
                                    baseInfoes.JobList.map((item, i) =>
                                        <option key={i} value={item.JobId}>{item.Job}</option>
                                    )
                                }
                            </select>
                        </div>
                        <div className="form-group col-md-3 mt-0">
                            <select className='form-control' placeholder='استان' onChange={e => loadCityList(e.target.value)} >
                                <option value="">استان را انتخاب کنید</option>
                                {provinceList && Array.isArray(provinceList) &&
                                    provinceList.map((item, i) =>
                                        <option key={i} value={item.Id}>{item.Name}</option>
                                    )
                                }
                            </select>
                        </div>
                        <div className="form-group col-md-3 mt-0">
                            <select className='form-control' placeholder='شهر'
                                onChange={e => searchData.current.CityID = e.target.value}>
                                <option value="">شهر را انتخاب کنید</option>
                                {cityList && Array.isArray(cityList) &&
                                    cityList.map((item, i) =>
                                        <option key={i} value={item.Id}>{item.Name}</option>
                                    )
                                }
                            </select>
                        </div>
                        <div className="form-group col-md-3 mt-0">
                            <input type="text" placeholder="آدرس" className="form-control" onChange={(e) => searchData.current.Address = e.target.value}  onKeyDown={search} />
                        </div>
                        <div className="form-group">
                            <input type='checkbox' className='form-check-input' style={{ cursor: "pointer" }} defaultChecked={true}  onKeyDown={search}
                                onChange={(e) => searchData.current.CampaignID = e.target.checked ? -1 : 0}
                            />
                            &nbsp;
                            <label style={{ color: "blue" }}>عضو هیچ کمپینی نباشد</label>
                        </div>
                    </div>
                }
                <Button className="group-Btn" variant='secondary' onClick={search}><Search />&nbsp;جستجوی مشتریان</Button>
                <br />
                <hr style={{ marginTop: "5px", marginBottom: "10px", color: "red" }} />
                {/* <div className='col-md-6'>
                    <input className='tableRowInput' id="inputSearch" style={{ display: "inline-block", width: "88%" }} />
                    <Button onClick={find} className="group-Btn-smalll"><Search size={16} /></Button>
                </div> */}

                <Table className='fixedTable mt-1 scrolledTable' id="custList" responsive>
                    <thead>
                        <tr>
                            <th style={{ width: "6%" }}>
                                <label style={{ color: "blue" }}>
                                    {(customerList.count || customerList.TotalCount) ? (customerList.count ^ customerList.TotalCount) : 0}
                                </label>
                            </th>
                            <th style={{ width: "5%" }}>
                                <input type='checkbox' className='form-check-input' style={{ cursor: "pointer" }} onChange={e => selectAll(e.target.checked)} />
                            </th>
                            <th style={{ width: "24%" }}>نام مشتری</th>
                            <th style={{ width: "15%" }}>موبایل</th>
                            <th style={{ width: "15%" }}>تلفن</th>
                            <th style={{ width: "35%" }}>آدرس</th>
                        </tr>
                    </thead>
                    <tbody>
                        {customerList === "PENDING" &&
                            <tr>
                                <td colSpan={5} style={{ textAlign: "center", width: "100%" }}>
                                    <Loader style={{ textAlign: "center" }} type="BallTriangle" color="rgb(228, 3, 117)" height={30} width={30} />
                                </td>
                            </tr>
                        }
                        {customerList && customerList.Data && customerList.Data.map((item, i) => {
                            return (
                                <tr className='resultTableRow' key={i} >
                                    <td style={{ width: "6%", color: "#d0620d" }}>{i + 1}</td>
                                    <td style={{ width: "5%", verticalAlign: "middle" }} >
                                        <input type='checkbox' className='form-check-input' style={{ cursor: "pointer" }}
                                            checked={selectedItems.find(i => i === item.ID)}
                                            onChange={(e) => setSelectedItems(e.target.checked, item)} />

                                    </td>
                                    <td style={{ width: "24%" }}>{item.Name}</td>
                                    <td style={{ width: "15%" }}>{(!item.Phone || item.Phone === "") ? "--" : item.Phone.substring(0, 12)}</td>
                                    <td style={{ width: "15%" }}>{(!item.Mobile || item.Mobile === "") ? "--" : item.Mobile.substring(0, 12)}</td>
                                    <td style={{ width: "35%" }}>{(!item.Address || item.Address === "") ? "--" : item.Address.substring(0, 50)}</td>
                                </tr>)
                        })}
                    </tbody>
                </Table>
                <Button className='group-Btn' onClick={select}><CheckSquare />&nbsp;انتخاب</Button>
                <Button className='group-Btn' variant='danger' onClick={close}><DashCircle />&nbsp;انصراف</Button>
            </Modal.Body>
        </Modal >
    )
}
export default ModalSelectCustomer;